export default {
  home: {
    title: 'USFans Spreadsheet: encuentra, compara y explora recursos de USFans',
    metaDescription: 'Explora recursos de USFans Spreadsheet, categorías de productos, guías de compra, información de envío y consejos de seguridad, todo en un centro multilingüe fácil de usar.',
    hero: {
      badge: 'Centro de recursos independiente',
      h1: 'USFans Spreadsheet: encuentra, compara y explora recursos de USFans',
      subtitle: 'Explora los recursos más recientes de USFans Spreadsheet, guías de productos, consejos de compra, información de envío y recursos de seguridad, todo organizado en un solo lugar fácil de usar.',
      trust1: 'Recursos organizados',
      trust2: 'Actualizaciones periódicas',
      trust3: 'Guías multilingües',
      trust4: 'Información de seguridad',
      dropdownLabel: 'Elige una categoría',
      dropdownPlaceholder: 'Selecciona una categoría de producto',
    },
    why: {
      title: '¿Por qué usar USFans Spreadsheet?',
      text: 'Encontrar recursos útiles de USFans puede ser difícil cuando la información está dispersa en distintos sitios web, comunidades y publicaciones. Nuestro objetivo es organizar la información más útil de USFans Spreadsheet en categorías claras, guías prácticas y comparaciones fáciles de entender.',
    },
    categories: {
      title: 'Explora las categorías de productos',
      subtitle: 'Salta directamente a la categoría que necesitas en el sitio web principal.',
      viewAll: 'Ver todas las categorías',
    },
    topics: {
      title: 'Temas populares de USFans',
      subtitle: 'Los temas que la gente más busca.',
      topic1Title: 'USFans Spreadsheet',
      topic1Desc: 'La visión completa de la hoja de cálculo, las categorías y los enlaces.',
      topic2Title: 'Reseña de USFans',
      topic2Desc: 'Qué saber antes de usar USFans, con pros y contras.',
      topic3Title: 'Coste de envío de USFans',
      topic3Desc: 'Entiende las tarifas, los plazos de entrega y cómo ahorrar.',
      topic4Title: 'Cupón de USFans',
      topic4Desc: 'Cómo encontrar cupones y ofertas de descuento actuales.',
      topic5Title: 'Código de descuento de USFans',
      topic5Desc: 'Una mirada práctica a dónde aparecen los códigos de descuento.',
      topic6Title: 'Almacén de USFans',
      topic6Desc: 'Cómo funciona el proceso de almacén, almacenamiento y control de calidad.',
      topic7Title: '¿Es legítimo USFans?',
      topic7Desc: 'Comprobaciones de seguridad y qué verificar antes de comprar.',
    },
    guides: {
      title: 'Guías más recientes',
      subtitle: 'Artículos originales y detallados para sacar más partido a USFans Spreadsheet.',
      readMore: 'Leer la guía',
      articleTitle: '¿Qué es USFans Spreadsheet? Una guía completa',
      articleCategory: 'Guía',
      articleReadingTime: '6 min de lectura',
      articleSummary: 'Una visión clara y original de cómo funciona USFans Spreadsheet, cómo explorar categorías, comparar productos y comprar con confianza.',
    },
    pillars: {
      title: 'Artículos pilares',
      subtitle: 'Guías detalladas sobre los temas más importantes, actualizadas con regularidad.',
      label: 'Guía',
      minRead: 'min de lectura',
      readMore: 'Leer la guía',
      items: {
        spreadsheetGuide: { title: '¿Qué es USFans Spreadsheet?', summary: 'Una visión clara de qué es la hoja de cálculo y cómo está organizada.' },
        howToUse: { title: 'Cómo usar USFans Spreadsheet', summary: 'Consejos paso a paso para explorar categorías y encontrar productos rápido.' },
        directory: { title: 'Directorio de USFans Spreadsheet', summary: 'Cómo el directorio agrupa productos y enlaces para facilitar la navegación.' },
        review: { title: 'Reseña de USFans: pros y contras', summary: 'Una mirada equilibrada a los puntos fuertes y a lo que hay que vigilar.' },
        shippingCost: { title: 'Guía de costes de envío de USFans', summary: 'Entiende las tarifas, los plazos y las formas prácticas de ahorrar.' },
        warehouse: { title: 'Guía del almacén de USFans', summary: 'Cómo funcionan el almacenamiento, el control de calidad y el envío.' },
        coupon: { title: 'Guía de cupones y códigos de USFans', summary: 'Dónde encontrar cupones y códigos de descuento actuales.' },
        legit: { title: '¿Es legítimo USFans?', summary: 'Comprobaciones de seguridad y qué verificar antes de comprar.' },
        buyingGuide: { title: 'Guía de compra de USFans', summary: 'Una lista práctica para una compra fluida e informada.' },
        safety: { title: 'Guía de seguridad de USFans', summary: 'Cómo verificar enlaces, pagos y mantenerte seguro en línea.' },
      },
    },
    safety: {
      title: 'Usa los recursos de USFans de forma más segura',
      text: 'Verifica siempre los enlaces, los precios actuales, la información de envío y los datos del vendedor antes de comprar. Nunca compartas contraseñas, códigos de autenticación ni datos de pago confidenciales con sitios web desconocidos.',
      cta: 'Leer la guía de seguridad',
      check1: 'Verifica el dominio',
      check2: 'Comprueba HTTPS',
      check3: 'Nunca compartas contraseñas',
      check4: 'Nunca compartas códigos de verificación',
    },
    faq: {
      title: 'Preguntas frecuentes',
      subtitle: 'Respuestas rápidas a las preguntas más comunes sobre USFans Spreadsheet.',
      q1: '¿Qué es USFans Spreadsheet?',
      a1: 'USFans Spreadsheet es una lista organizada de productos de moda y ropa urbana de EE. UU. y enlaces de compra, agrupada en categorías claras como zapatos, sudaderas, camisetas y accesorios para que encuentres lo que necesitas más rápido.',
      q2: '¿Es gratis usar USFans Spreadsheet?',
      a2: 'Explorar las categorías y las guías es gratis. Verifica siempre los precios actuales, los detalles de envío y la información del vendedor en el sitio web principal antes de comprar.',
      q3: '¿Cómo encuentro un producto concreto?',
      a3: 'Usa el menú desplegable de categorías o los botones de categorías de esta página para saltar directamente a la sección correspondiente del sitio web principal.',
      q4: '¿Es legítimo USFans?',
      a4: 'Siempre recomendamos verificar los enlaces, comprobar HTTPS y confirmar los datos del vendedor y del pago por tu cuenta antes de comprar. Trata cualquier sitio web desconocido con cuidado.',
      q5: '¿Qué debo comprobar antes de comprar?',
      a5: 'Comprueba los precios actuales, los costes y plazos de envío, las políticas de devolución y los datos del vendedor. La información puede cambiar, así que confirma los últimos detalles en el sitio web principal.',
      q6: '¿Con qué frecuencia se actualiza la información?',
      a6: 'Intentamos mantener las guías y categorías actualizadas, pero confirma siempre los listados y precios actuales en el sitio web principal antes de comprar.',
    },
    final: {
      title: '¿Listo para explorar los recursos de USFans Spreadsheet?',
      text: 'Empieza con el centro de USFans Spreadsheet y descubre guías, comparaciones, reseñas, información de envío y recursos prácticos.',
    },
  },
};